import {UntypedFormControl} from '@angular/forms';

export function validateHorizontalRange(control: UntypedFormControl) {
    if (control.value > 180 || control.value < -180){
        return { validateHorizontalRange: true };
    }
    return null;
}
